import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ElderlyWomanIcon(props: IconProps) {
    return <Icon {...props} iconKey={"elderly_woman"}/>
}
